import { Box } from "@mui/material";

type LogoType = {
  type?: "light" | "dark";
  size?: "small" | "medium" | "large";
};

const logos = {
  light: "/images/logo-purple.svg",
  dark: "/images/logo-white.svg",
};

const sizes = {
  small: "50px",
  medium: "150px",
  large: "",
};

export function Logo(props: LogoType): JSX.Element {
  const type = props.type ? props.type : "light";
  const src = logos[type];
  const width = props.size ? sizes[props?.size] : "medium";

  return (
    <Box
      sx={{
        display: { xs: "none", md: "flex" },
        alignItems: "center",
        overflow: "hidden",
        width: width,
      }}
    >
      <img src={src} alt="لوگو آقای پرداخت" />
    </Box>
  );
}
